import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { Link } from "react-router-dom";
import { Apple, Play, Globe } from "lucide-react";
import { Reveal } from "../landing/Reveal";

const EXP_URL =
  "exp://study-social-eat.preview.emergentagent.com?expo_go_prompt_device_auth=1&expo_go_device_auth_verification_uri_override=app.emergent.sh";

const STORES = [
  { icon: Play, label: "Google Play" },
  { icon: Apple, label: "App Store" },
  { icon: Globe, label: "Web" },
];

export const BiteDownload = () => {
  const [qr, setQr] = useState(null);
  useEffect(() => {
    QRCode.toDataURL(EXP_URL, { width: 512, margin: 1 }).then(setQr).catch(() => {});
  }, []);

  return (
    <section id="download" data-testid="bite-download" className="relative overflow-hidden py-20 sm:py-24">
      <div aria-hidden="true" className="absolute left-1/2 top-1/2 h-[380px] w-[640px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#7C3AED]/12 blur-[140px]" />
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
        <Reveal>
          <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#06B6D4]">Download App</p>
          <h2 className="mx-auto mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Your whole campus. One pocket. 🚀
          </h2>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
            {STORES.map((s) => (
              <Link
                key={s.label}
                to="/qr"
                data-testid={`bite-store-${s.label.toLowerCase().replace(" ", "-")}`}
                className="flex items-center gap-2.5 rounded-full border border-white/10 bg-white/[0.04] px-6 py-3.5 text-sm font-semibold text-white backdrop-blur-xl transition-colors hover:border-[#06B6D4]/60"
              >
                <s.icon className="h-4 w-4 text-[#06B6D4]" />
                {s.label}
              </Link>
            ))}
          </div>
          <div className="mt-10 flex flex-col items-center gap-4">
            <div className="rounded-3xl border border-white/10 bg-white p-3 shadow-[0_20px_80px_-20px_rgba(0,245,160,0.35)]">
              {qr ? (
                <img src={qr} alt="QR code to open the FUNZ app preview" data-testid="bite-qr" className="h-36 w-36" />
              ) : (
                <div className="h-36 w-36 animate-pulse rounded-xl bg-neutral-200" />
              )}
            </div>
            <p className="max-w-xs text-sm text-slate-400">
              Scan with your phone camera to open the live app preview instantly.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
